import { render, staticRenderFns } from "./ClientEmailBodyTemplate.vue?vue&type=template&id=1f56f916&scoped=true&"
import script from "./ClientEmailBodyTemplate.vue?vue&type=script&lang=ts&"
export * from "./ClientEmailBodyTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ClientEmailBodyTemplate.vue?vue&type=style&index=0&id=1f56f916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56f916",
  null
  
)

export default component.exports